// extracted by mini-css-extract-plugin
module.exports = {"home-battery-E":"E_home-battery-E__nJbp9"};